export { supabase } from "./client.web";
export type { TypedSupabaseClient } from "./client.web";
export { resolveStorageUrl } from "./constants";
export { Constants } from "./types/database";
export type { Enums } from "./types/database";

export type {
  Session,
  User,
  AuthError,
  AuthResponse,
  AuthTokenResponse,
  QueryData,
} from "@supabase/supabase-js";
